import { render, staticRenderFns } from "./UploadTest.vue?vue&type=template&id=753fb146&scoped=true"
import script from "./UploadTest.vue?vue&type=script&lang=ts"
export * from "./UploadTest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753fb146",
  null
  
)

export default component.exports